<template>
<!-- 商品管理 -->
<div class="viewContainer">
  <div v-if="dialogVisible">
    <el-tabs type="card" v-model="tabsName" @tab-click="handleTab">
      <el-tab-pane label="商品管理" name="first"/>
      <el-tab-pane label="分类管理" name="second"/>
    </el-tabs>
    <!-- 商品管理 -->
    <div v-show="tabsName=='first'">
      <div class="main_container">
        <div class="fuji" @click="show3 = !show3">
          <div class="goodslist1">
            <span style="margin-left:20px;margin-top:5px">搜索/查询</span>
            <span class="divReset" @click.stop="fnReset"><img src="../../assets/img/Reset.png" alt /></span>
          </div>
          <div style="position: absolute;right:0;top:-10px" class="sanjiao"></div>
        </div>
        <!-- 顶部搜索框 -->
        <el-collapse-transition>
        <div v-show="show3">
          <el-form class="findform">
            <el-form-item label="商品名称：" style="display:flex;width:30%">
              <el-input v-model="goodsName" placeholder="请输入商品名称" style="width:90%"/>
            </el-form-item>
            <el-form-item> <el-button type="danger" @click="onSubmit">查询</el-button> </el-form-item>
          </el-form>
        </div>
        </el-collapse-transition>
      </div>
      <div class="main_container">
      <section class="model_section">
        <p class="model_top_title">商品管理</p>
        <div style="float: right;margin-right: 10px;">
          <span v-show="this.newShopType == 1" style="margin-right: 15px;">{{resultMsg}}</span>
          <el-button type="danger" @click="selSpread()" v-show="this.newShopType == 1">设置推荐</el-button>
          <el-button type="primary" @click="handleqxbj()" v-show="isEditingSort"> 取消编辑 </el-button>
          <el-button type="primary" @click="saveSort()" v-show="isEditingSort"> 保存排序 </el-button>
          <el-button type="danger" @click="editSort()" v-show="!isEditingSort"> 编辑排序 </el-button>
          <el-button type="danger" @click="showadd()">新增商品</el-button>
          <!-- <el-button @click="endSetUpCoCreation()" class="blackGoldCard">设置黑金卡佣金比例</el-button> -->
        </div>
      </section>
      <!-- 橱窗商品列表 -->
      <div class="table_container">
      <el-table :data="goodListInfo" stripe border @selection-change="handleSelectionChange">
        <el-table-column type="selection" align="center" width="60px"/>
        <!-- <el-table-column label="序号" align="center" width="60px">
          <template scope="scope">{{scope.$index + 1}}</template>
        </el-table-column> -->
        <el-table-column label="排序" align="center" width="80px">
          <template scope="scope">
            <el-input v-if="isEditingSort" v-model="scope.row.sort" maxlength="3"
            oninput="value=value.replace(/[^\d]/g,'')" style="width: 100%; text-align: center;"
            onkeyup="value=value.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, '$1')"/>
            <span v-else>{{ scope.row.sort }}</span>
          </template>
        </el-table-column>
        <el-table-column label="商品名称" align="center" min-width="150px">
          <template scope="scope">
            <span class="spanList" :title="scope.row.goodsName">
              {{scope.row.goodsName}}</span>
          </template>
        </el-table-column>
        <el-table-column label="商品编码" align="center" min-width="150px">
          <template scope="scope"> <span>{{scope.row.goodsCode}}</span></template>
        </el-table-column>
        <el-table-column label="品牌" align="center" width="100px" v-if="this.newShopType == 1">
          <template scope="scope">
            <span class="spanList" :title="scope.row.goodsBrandTypeName">
            {{scope.row.goodsBrandTypeName}}</span>
          </template>
        </el-table-column>
        <el-table-column label="商品类型" align="center" width="100px">
          <template scope="scope"><span>{{scope.row.commodityTypeName}}</span></template>
        </el-table-column>
        <el-table-column label="市场价" align="center" v-if="this.newShopType == 1">
          <template scope="scope"><span>{{scope.row.marketPrice}}</span></template>
        </el-table-column>
        <el-table-column label="商品价格" align="center">
          <template scope="scope"><span>{{scope.row.promotionPrice}}</span></template>
        </el-table-column>
        <el-table-column label="商品分类" align="center" width="100px">
          <template scope="scope">
            <span class="spanList">{{scope.row.tagName}}</span>
          </template>
        </el-table-column>
        <el-table-column label="浏览数" align="center" width="100px">
          <template scope="scope"><span>{{scope.row.browseCount}}</span></template>
        </el-table-column>
        <el-table-column label="有效时间" align="center">
          <template scope="scope"><span>{{scope.row.permanateName}}</span></template>
        </el-table-column>
        <el-table-column label="最后操作人" align="center" width="110px">
          <template scope="scope"><span>{{scope.row.lastEditUserName}}</span></template>
        </el-table-column>
        <el-table-column label="最后操作时间" align="center" width="150px">
          <template scope="scope"><span>{{scope.row.lastEditTime}}</span></template>
        </el-table-column>
        <el-table-column label="操作" fixed="right" align="center" width="260px">
          <template scope="scope">
            <!-- <a href="javascript:;" @click="onshop(scope.row)" class="ahref">{{scope.row.isOnSale == 0?"上架":"下架"}}</a>
            <a href="javascript:;" class="ahref" @click="editinfo(scope.row)">编辑</a> -->
            <span @click="editinfo(scope.row, 1)" class="handle"> <i class="el-icon-edit-outline"/> 编辑 </span>
            <!-- <a href="javascript:;" @click="onshop(scope.row)" class="ahref">{{scope.row.IsOnline == 0?"上架":"下架"}}</a> -->
            <span @click="onshop(scope.row)" class="handle">
              <i :class="scope.row.isOnSale == 0?'el-icon-upload2':'el-icon-download'"/>
              {{scope.row.isOnSale == 0?"上架":"下架"}}
            </span>
            <span @click="upordown(1, scope.row)" class="handle"> <i class="el-icon-upload2" />向上 </span>
            <span @click="upordown(2, scope.row)" class="handle"> <i class="el-icon-download" />向下 </span>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination layout="total, sizes, prev, pager, next" @size-change="handleSizeChange" @current-change="handleCurrentChange"
      :current-page="pageIndex" :page-sizes="[10, 20, 30, 50]" :page-size="pageSize" :total="total" style="float: right; margin: 10px 0;"/>
      </div>
      </div>
    </div>
    <!-- 分类管理 -->
    <div v-show="tabsName=='second'" class="main_container">
      <section class="model_section">
        <el-col :span="18" style>
          <p class="model_top_title">分类列表</p>
        </el-col>
        <el-col :span="6">
          <el-button type="danger" @click="handlefl()" style="float: right;margin: 5px 10px 10px 0;">新增</el-button>
        </el-col>
      </section>
      <div class="table_container">
      <el-table :data="classificationList" stripe border>
        <el-table-column label="序号" align="center" width="50px">
          <template scope="scope">{{scope.$index + 1}}</template>
        </el-table-column>
        <el-table-column label="分类名称" align="center">
          <template scope="scope">{{scope.row.tagname}}</template>
        </el-table-column>
        <el-table-column label="商品数量" align="center">
          <template scope="scope">{{scope.row.goodscount}}</template>
        </el-table-column>
        <el-table-column label="操作" fixed="right" align="center">
          <template scope="scope">
            <span @click="endDeletefl(scope.row)" class="handle"> <i class="el-icon-delete"></i> 删除 </span>
            <span @click="handlefl(scope.row)" class="handle"> <i class="el-icon-edit-outline"></i> 编辑 </span>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination layout="prev, pager, next" @current-change="handlePagination"
      :current-page="pageflIndex" :page-size="10" :total="totalfl" style="float:right;margin:10px 0;"/>
      </div>
    </div>
  </div>
  <!-- 新增/编辑橱窗商品 弹框 -->
  <div v-else>
    <el-tabs type="card" v-model="activeName" @tab-click="handleClick">
      <el-tab-pane label="商品信息" name="spxx"/>
      <el-tab-pane label="配置清单" name="pzqd" v-if="this.newShopType == 2"/>
      <el-tab-pane label="空间效果" name="kjxg" v-if="this.newShopType == 2"/>
    </el-tabs>
    <!-- 商品信息 -->
    <div class="main_container" v-show="activeName == 'spxx'" style="padding: 20px 0;">
      <el-form :inline="true" :model="formInline" label-width="120px">
        <el-row v-if="this.newShopType == 1">
          <el-col :span="11">
          <el-form-item label="商品品牌：" style="display:flex;">
            <el-cascader v-model="pinpai" placeholder="请选择" style="width:80%"
            :options="options" filterable clearable @change="handleChange"/>
          </el-form-item>
          </el-col>
          <el-col :span="12">
          <el-form-item label="商品类型：" style="display:flex;">
            <el-select v-model="formInline.commodityTypeId" placeholder="请选择" @change="changeProductType" style="width:80%">
              <el-option v-for="(item,index) in commodityType" :key="index" :label="item.name" :value="item.id"/>
            </el-select>
          </el-form-item>
          </el-col>
        </el-row>
        <el-row v-if="this.newShopType == 2">
          <el-col :span="11">
          <el-form-item label="商品类型：" style="display:flex;">
            <el-select v-model="formInline.constructionId" placeholder="请选择" style="width: 80%;">
              <el-option v-for="item in constructionMethod" :key="item.id" :value="item.id" :label="item.name"/>
            </el-select>
          </el-form-item>
          <!-- <el-form-item label="最低购买数量 :" style="display:flex;width: 23%;">
            <el-input v-model="formInline.pingmishu" placeholder="最低购买数量" maxlength="9"
                      type="text" onkeyup="value=value.replace(/[^\d]/g,'');"/>
          </el-form-item> -->
          </el-col>
          <el-col :span="12">
          <el-form-item label="适用面积：" style="display:flex;">
            <el-input v-model="formInline.minimum" maxlength="10" placeholder="最小面积"
            oninput="value=value.replace(/[^\d]/g,'')" style="width:12vh;"
            onkeyup="value=value.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, '$1')" @blur="formInline.minimum = $event.target.value"/>
            <label style="margin: 0 5px">至</label>
            <el-input v-model="formInline.maximum" maxlength="10" placeholder="最大面积"
            oninput="value=value.replace(/[^\d]/g,'')" style="width:12vh;"
            onkeyup="value=value.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, '$1')" @blur="formInline.maximum = $event.target.value"/> 平米
          </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="11">
          <el-form-item label="商品编码：" style="display:flex;">
            <el-input v-model="formInline.commodityCode" maxlength="50" placeholder="请输入商品编码" v-if="addId" style="width:80%"/>
            <el-autocomplete v-model="formInline.commodityCode" placeholder="请输入商品编码" v-else style="width:80%" maxlength="50"
            :fetch-suggestions="querySearchAsync" @select="handleSelect" value-key='goodsCode' :trigger-on-focus="false"/>
          </el-form-item>
          </el-col>
          <el-col :span="12">
          <el-form-item label="商品单位：" style="display:flex;" v-if="this.newShopType == 1">
            <el-select v-model="formInline.danweiId" placeholder="请选择" style="width:80%" @change="changedw"
            :disabled="formInline.commodityTypeId == 2 || formInline.commodityTypeId == 6">
              <el-option v-for="item in danwei" :key="item.id" :value="item.Id" :label="item.Name"/>
            </el-select>
          </el-form-item>
          <el-form-item label="商品单位：" style="display:flex;" v-if="this.newShopType == 2">
            <el-select v-model="formInline.spdanwei" placeholder="请选择" style="width:60%">
              <el-option v-for="item in spdanweiArr" :key="item.id" :value="item.id" :label="item.name"/>
            </el-select>
            <el-input v-model="formInline.zidingyi" maxlength="4" placeholder="请输入"
            v-if="formInline.spdanwei == 0" style="width: 20%;"/>
          </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="11">
          <el-form-item label="商品名称：" style="display:flex;">
            <el-input v-model="formInline.tradeName" maxlength="30" placeholder="请输入商品名称" style="width:80%"/>
          </el-form-item>
          </el-col>
          <el-col :span="12">
          <el-form-item label="库存(选填)：" style="display:flex;" v-if="this.newShopType == 1">
            <el-input v-model="formInline.stock" placeholder="请输入商品库存" maxlength="9" style="width:80%"
            onkeyup="value=value.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, '$1')"/>
          </el-form-item>
          <!-- <span style="line-height: 38px;">(选填)</span> -->
          </el-col>
        </el-row>
        <el-row v-if="this.newShopType == 1">
          <el-col :span="11">
          <el-form-item label="市场价格：" style="display:flex;">
            <el-input type="text" v-model="formInline.marketPriceOfCommodities" placeholder="请输入商品市场价" maxlength="9"
            onkeyup="value=value.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, '$1')" style="width:70%">
            <i slot="suffix" style="margin-right: 10px;">元</i>
            </el-input>　(选填)
          </el-form-item>
          </el-col>
          <el-col :span="12">
          <el-form-item label="商品描述：" style="display:flex;">
            <el-input v-model="formInline.describe" maxlength="20" placeholder="最多可输入20个汉字" style="width:80%"/>
          </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="11">
          <el-form-item label="促销价格：" style="display:flex;" v-if="this.newShopType == 1">
            <el-input type="text" v-model="formInline.promotionPrice" placeholder="请输入商品促销价" maxlength="9"
            onkeyup="value=value.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, '$1')" style="width: 80%;">
            <i slot="suffix" style="margin-right: 10px;">元</i>
            </el-input>
          </el-form-item>
          <el-form-item label="商品价格：" style="display:flex;" v-if="this.newShopType == 2">
            <el-input type="text" v-model="formInline.promotionPrice" placeholder="请输入商品价格" maxlength="9"
            onkeyup="value=value.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, '$1')" style="width: 80%;">
            <i slot="suffix" style="margin-right: 10px;">元</i>
            </el-input>
          </el-form-item>
          </el-col>
          <el-col :span="12">
          <el-form-item label="分类(选填)：" style="display:flex;">
            <el-select v-model="formInline.spflId" placeholder="请选择" style="width: 60%;">
              <el-option v-for="item in spflArr" :key="item.tagid" :value="item.tagid" :label="item.tagname"/>
            </el-select>
            <el-button type="danger" size="small" @click="handlefl()" style="margin-left: 10px;">添加</el-button>
          </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="11">
          <el-form-item label="有效期限：" style="display:flex;">
            <el-date-picker type="daterange" v-model="formInline.isPromotionId" :editable="false"
              @change="changetime" :picker-options="pickerOptions" range-separator="至" value-format="yyyy-MM-dd"
              start-placeholder="开始日期" end-placeholder="结束日期" :disabled="IsNoLimit == 1" style="width:60%;"/>
            <el-checkbox v-model="IsNoLimit" style="margin-left: 10px;">长期有效</el-checkbox>
          </el-form-item>
          </el-col>
          <el-col :span="12">
          <el-form-item label="线上购买：" style="display:flex;">
            <el-checkbox v-model="formInline.zaixianfukuan">在线付款</el-checkbox>
          </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="11">
          <el-form-item label="商品图片：" style="display:flex;margin-bottom: 5px;">
            <div style="display:flex;flex-wrap:wrap">
              <div v-for="(item,index) in imgarr" :key="index" style="display:inline-block; position: relative;line-height: normal;">
                <img @click="deleteimg(index,item)" src="../../assets/img/aicon36.png"
                style="position:absolute;right:6px;top:-8px;cursor: pointer;z-index: 9;width: 20px;"/>
                <el-image :src="item" @click="handleClickItem" :preview-src-list="imgarr" fit="cover"
                style="width:80px;height:80px;margin-right:15px"/>
              </div>
              <el-upload v-show="isdisabled" class="avatar-uploader" style action :show-file-list="false" :before-upload="beforeAvatarUpload">
                <img style="width:80px;height:80px;" v-if="CoverImg" :src="CoverImg" class="avatar"/>
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              </el-upload>
            </div>
            <div style="color:#888;">建议尺寸：1200*1200，支持的图片格式：jpg、png；单张图片不大于5M。</div>
          </el-form-item>
          </el-col>
          <el-col :span="12">
          <el-form-item label="商品视频：" style="display:flex;">
            <div v-if="videoSrc" class="videoClass">
              <span @click="newSeevideo(videoSrc)" class="previewingVideo">
                <img :src="videoImg" v-if="videoImg">
                <img src="../../assets/img/spfm.png" v-else>
                <div class="iconcontainer"><img src="../../assets/img/play.png" class="playIcon"/></div>
              </span>
              <img src="../../assets/img/aicon36.png" @click="delvideo()" v-if="videoSrc" class="chahao"/>
            </div>
            <el-upload v-else class="avatar-uploader-zstp" action="" accept="video/*" :before-upload="handleFile">
              <el-progress type="circle" v-if="videoFlag" :percentage="videoUploadPercent" :width="80" :height="80"/>
              <i v-else class="el-icon-plus avatar-uploader-icon"/>
            </el-upload>
            <div style="color:#888;">视频格式仅支持: mp4. 视频大小不能超过 50MB !</div>
          </el-form-item>
          </el-col>
        </el-row>
        <!-- <el-row>
          <el-col :span="11">
          
          </el-col>
          <el-col :span="12">
          
          </el-col>
        </el-row> -->
        <el-form-item label="商品详情：" label-width="118px" style="display:flex;width: 60%;">
          <!-- 富文本编辑器组件 -->
          <wjEditor :desc="content1" @change="contentChangeOne"/>
        </el-form-item>
        
        <!-- <el-form-item label="预购定金 :" style="display:flex;width: 23%;" v-if="formInline.commodityTypeId != 3">
          <el-input v-model="formInline.advanceDeposit" placeholder="请输入预购定金" maxlength="9"
            type="text" onkeyup="value=value.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, '$1')"/>
        </el-form-item> -->

      </el-form>
      
      <!-- 可编辑table区域 -->
      <!-- <el-form :inline="true" :model="formInline" v-if="this.newShopType == 2" style="display:flex;">
        <el-form-item label="付款比例 :" style="display:flex;width: 36%;">
          <el-table :data="MoneyTableData" stripe border :header-cell-style="{padding: '0', background:'#fff'}">
            <el-table-column label="款项名称" align="center">
              <template slot-scope="scope">
                <el-input v-model="scope.row.name" placeholder="请输入款项名称" maxlength="6"/>
              </template>
            </el-table-column>
            <el-table-column label="付款比例" align="center">
              <template slot-scope="scope">
                <el-input v-model="scope.row.rate" placeholder="请输入付款比例" maxlength="6"
                          oninput = "value=value.replace(/[^\d]/g,'')"
                          type="Number" onkeyup="value=value.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, '$1')"/>
              </template>
            </el-table-column>
            <el-table-column label="操作" fixed="right" align="center">
              <template slot-scope="scope">
                <el-button type="danger" size="mini" @click="addLine" style="margin: 6px 3px;"
                          v-if="scope.$index == MoneyTableData.length - 1">新增</el-button>
                <el-button size="mini" @click="handleDelete(scope.$index, scope.row)" style="margin: 6px 3px;"
                          v-if="MoneyTableData.length > 1"> 删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-form-item>
      </el-form> -->

      <!-- 单个产品佣金配置 -->
      <!-- 可编辑table区域 -->
      <!-- <el-form :inline="true" :model="formInline" v-show="newUserType == 5 || newBbId == 1" style="display:flex;">
        <el-form-item label="单个产品佣金配置 :" style="display:flex;width: 90%;">
          <el-checkbox v-model="checkedEnable">启用自定义佣金分发比例</el-checkbox>
          <el-table :data="commissionAllocationData" stripe border>
            <el-table-column label="平台 (%)" align="center">
              <template slot-scope="scope">
                <el-input v-model="scope.row.platformRate" placeholder="请输入" maxlength="6"/>
              </template>
            </el-table-column>
            <el-table-column label="消费者 (%)" align="center">
              <template slot-scope="scope">
                <el-input type="text" v-model="scope.row.userRate" placeholder="请输入" maxlength="6"
                          oninput = "value=value.replace(/[^\d]/g,'')" onkeyup="value=value.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, '$1')"/>
              </template>
            </el-table-column>
            <el-table-column label="一级共创 (%)" align="center">
              <template slot-scope="scope">
                <el-input type="text" v-model="scope.row.firstCoRate" placeholder="请输入" maxlength="6"
                          oninput = "value=value.replace(/[^\d]/g,'')" onkeyup="value=value.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, '$1')"/>
              </template>
            </el-table-column>
            <el-table-column label="二级共创 (%)" align="center">
              <template slot-scope="scope">
                <el-input type="text" v-model="scope.row.secondCoRate" placeholder="请输入" maxlength="6"
                          oninput = "value=value.replace(/[^\d]/g,'')" onkeyup="value=value.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, '$1')"/>
              </template>
            </el-table-column>
            <el-table-column label="共创池 (%)" align="center">
              <template slot-scope="scope">
                <el-input type="text" v-model="scope.row.coRate" placeholder="请输入" maxlength="6"
                          oninput = "value=value.replace(/[^\d]/g,'')" onkeyup="value=value.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, '$1')"/>
              </template>
            </el-table-column>
            <el-table-column label="合伙人 (%)" align="center">
              <template slot-scope="scope">
                <el-input type="text" v-model="scope.row.partnerRate" placeholder="请输入" maxlength="6"
                          oninput = "value=value.replace(/[^\d]/g,'')" onkeyup="value=value.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, '$1')"/>
              </template>
            </el-table-column>
            <el-table-column label="导购 (%)" align="center">
              <template slot-scope="scope">
                <el-input type="text" v-model="scope.row.guideRate" placeholder="请输入" maxlength="6"
                          oninput = "value=value.replace(/[^\d]/g,'')" onkeyup="value=value.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, '$1')"/>
              </template>
            </el-table-column>
            <el-table-column label="BD佣金 (%)" align="center">
              <template slot-scope="scope">
                <el-input type="text" v-model="scope.row.bdRate" placeholder="请输入" maxlength="6"
                  oninput = "value=value.replace(/[^\d]/g,'')" onkeyup="value=value.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, '$1')"/>
              </template>
            </el-table-column>
            <el-table-column label="设计师佣金 (%)" align="center">
              <template slot-scope="scope">
                <el-input type="text" v-model="scope.row.designerRate" placeholder="请输入" maxlength="6"
                  oninput = "value=value.replace(/[^\d]/g,'')" onkeyup="value=value.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, '$1')"/>
              </template>
            </el-table-column>
          </el-table>
        </el-form-item>
      </el-form> -->
    </div>
    <!-- 配置清单 -->
    <div class="main_container" v-show="activeName == 'pzqd'" style="padding-top: 20px;">
      <el-form style="margin-left: 20px;">
        <el-form-item label="配置清单 :" style="display:flex;width: 80%;">
          <!-- 富文本编辑器组件 -->
          <wjEditor :desc="content2" @change="contentChangetWO"/>
        </el-form-item>
      </el-form>
    </div>
    <!-- 空间效果 -->
    <div class="main_container" v-show="activeName == 'kjxg'">
      <el-form v-if="this.newShopType == 2" class="spaceEffect">
        <el-form class="dottedLine" v-for="(item,index) in journalArr" :key="index">
          <div class="sahnchuDiv">
            <p style="color: #888;">温馨提示：标签名称长度不超过6个字；图片尺寸建议：1200*745 px 每个标签最多支持15张图片 </p>
            <el-button type="warning" @click="shanchu(index)" class="shanBtn">刪除</el-button>
          </div>
          <el-form-item label="标签名称 :" style="width:80%;">
            <el-input type="textarea" v-model="item.labelName" placeholder="例: 客厅" maxlength="6" style="width:80%"/>
          </el-form-item>
          <el-form-item label="多图上传 :" style="width:80%;">
            <div class="upPictures">
              <div class="multigraph" v-for="(img,index) in item.imgs" :key="index" :data-img="img">
                <el-image :src="img" style="width: 80px; height:80px" @click="handleClickItem" :preview-src-list="[img]"/>
                <div class="chahao" @click.stop="deldetail(item, index)">
                  <img src="../../assets/img/aicon36.png"/>
                </div>
              </div>
              <!-- 上传图片 -->
              <el-upload action multiple v-if="item.imgs.length < 15" accept=".png, .jpg,.jpeg"
              :limit="15" :before-upload="(file)=>multiGraphUpload(file, item)">
                <i class="el-icon-plus upBtn"></i>
              </el-upload>
            </div>
          </el-form-item>
        </el-form>
        <div class="primarybtn" v-if="journalArr.length < 6">
          <el-button type="primary" @click="addJournal()">添加空间效果</el-button>
        </div>
      </el-form>
    </div>
    <div class="gudingdibu">
      <el-button @click="dialogVisible = true">取消</el-button>
      <el-button type="danger" @click="endAddAndEdit()" :loading="loadingBut">{{loadingButText}}</el-button>
    </div>
  </div>
  <!-- 上架弹框 -->
  <el-dialog title="提示" :visible.sync="shangjiadialog" width="30%" :before-close="handleClose">
    <span>{{type==0?"您确定上架此商品么?":"您确定下价架此商品么?"}}</span>
    <span slot="footer" class="dialog-footer">
    <div style="text-align:center">
    <el-button type="danger" @click="makesure()">确定</el-button>
    <el-button @click="shangjiadialog = false">取消</el-button>
    </div>
  </span>
  </el-dialog>

  <!-- 播放视频 -->
  <el-dialog title='视频播放' :visible.sync="videoVisible" @close="closeVideo" width="30%" center>
    <video-player ref="videoPlayer" class="video-player vjs-custom-skin" :playsinline="true" :options="playerOptions" />
  </el-dialog>

  <!-- 分类 -->
  <el-dialog :title="flTitle" :visible.sync="isToFl" :center="true" width="25%">
    <el-form>
      <el-form-item label="" style="width:100%">
        <el-input v-model="flName" placeholder="请输入分类名称，不超过5个字" maxlength="5"/>
      </el-form-item>
    </el-form>
    <!-- 弹框按钮 -->
    <div style="text-align:center">
      <el-button type="button" @click="isToFl = false">取消</el-button>
      <el-button type="danger" @click="editSubmit()">确定</el-button>
    </div>
  </el-dialog>
  
  <!-- 初始化弹框 -->
  <el-dialog :center="true" title="请选择店铺" :visible.sync="initdialog" width="25%">
    <el-form class="findform">
      <el-form-item label="店铺名称：" style="display:flex;">
        <el-select v-model="bbid" filterable placeholder="请选择店铺" @change="handleChangeType">
          <el-option v-for="item in options1" :key="item.id" :value="item.id" :label="item.name"/>
        </el-select>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button type="danger" @click="gonext()">确定</el-button>
    </div>
  </el-dialog>
  
</div>
</template>
<script>
import alertTrends from '../../common/alertTrends.js';
import { uploadOSS } from '../../utils/oss';
import {getOssFile, uploadVedio, userIdentity} from '../../api/newOss';
import wjEditor from '../../components/MyWangEditor'
import {getkind, EditBBShopIsOpenAndIsCertificate, getMerchantGoodsBrandTypeList } from "../../api/api";
import { postAddGoodsWindow, putEditGoodsWindow, getGoodsWindowDetails, getUnit, goodsType,
  getGoodsWindowList, selSpread, getBbBearRangr, getSearchWindowsGoods, putSetSort, goodssetsort,
  getgoodstaglist, addgoodstag, getgetinfo, editgoodstag, delgoodstag, getshoptaglist, } from "../../api/shopWindow";

export default {
  name: "commoditymanagement",
  components: { wjEditor },
  mixins: [alertTrends],
  data() {
    return {
      show3: true,
      content1: '', // 新版富文本 - 商品介绍
      content2: '', // 新版富文本 - 配置清单
      newShopType: 1, // 店铺类型 品牌商类型 1=建材商、2=装修公司
      goodListInfo: [], // 橱窗列表数据
      options: [],
      pinpai: "",
      formInline: {
        BrandTypeId: 0, // 品类
        BrandId: 0, // 品牌
        danweiId: 0, // 单位
        commodityTypeId: 0, // 商品类型
        spflId: '', // 商品分类
        zaixianfukuan: false, // 在线付款
        constructionId: '', // 施工方式
        pingmishu: 0, // 平米数
        minimum: 60, // 适用最小面积
        maximum: 120, // 适用最大面积
        commodityCode:"", // 商品编码
        tradeName:"", // 商品名称
        spdanwei: 999, // 商品单位
        zidingyi: '', // 自定义
        describe: "", // 商品描述
        stock:"", // 库存
        marketPriceOfCommodities: "", // 商品市场价
        promotionPrice: "", // 商品促销价
        // advanceDeposit: "", // 预购定金
        isPromotionId: "", //有效期
        shopWindowStartTime: "", //商品有效期开始时间
        shopWindowEndTime: "", //商品有效期结束时间
      },
      lsdwId: 0, // 暂存单位
      spdanweiArr: [], // 商品单位
      constructionMethod: [], // 施工方式
      IsNoLimit: true, // 长期有效 默认勾选
      fileName:"",
      bbId:"",
      type:0,
      shopinfo:"",
      addId:0,
      imgarr: [], // 全连接
      FileID: [], // 切割之后的
      isdisabled: true,
      // 商品类型
      commodityType: [],
      spflArr: [], // 商品分类
      // 商品介绍
      ueditor: {
        value: ``,
        configuration: '', // 配置清单
      },
      CoverImg:"",
      shangjiadialog:false,
      fileList: [],
      dialogVisible: true,
      pageIndex: 1,
      pageSize: 10,
      total: 10,
      // 活动时间限制
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now()-8.64e7;
        },
      },
      MoneyTableData:[{
        name: '', // 款项名称
        rate: 0, // 付款比例
      }],
      // 单个产品佣金配置
      commissionAllocationData: [{
        platformRate: 0, // 平台
        userRate: 0, // 消费者
        firstCoRate: 0, // 一级共创
        secondCoRate: 0, // 二级共创
        coRate: 0, // 共创池
        partnerRate: 0, // 合伙人
        guideRate: 0, // 导购
        bdRate: 0, // BD佣金
        designerRate: 0, // 设计师佣金
      }],
      checkedEnable: false, // 启用自定义佣金分发比例 - 默认不勾选
      newUserType: "", // 超级管理员
      newBbId: "", // 平台员工
      danwei: [], // 单位数组
      goodsName:"",
      dowindowArr:[],
      resultMsg:"",
      
      videoImg: '', // 视频封面图
      videoSrc: "", // 全连接
      videoShortSrc: "", // 切割之后链接
      videoFlag: false, // 进度条显隐
      videoUploadPercent: 0, // 圆形进度条
      //视频播放
      videoVisible: false,
      playerOptions: {
        autoplay: false, // 如果true,浏览器准备好时开始回放。
        muted: false, // 默认情况下将会消除任何音频。
        loop: false, // 导致视频一结束就重新开始。
        preload: 'auto', // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        language: 'zh-CN',
        aspectRatio: '4:3', // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
        fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
        sources: [{
          src: "" // 视频url地址
        }],
        poster: '', // 你的封面地址
        width: document.documentElement.clientWidth, //播放器宽度
        notSupportedMessage: '此视频暂无法播放，请稍后再试', // 允许覆盖Video.js无法播放媒体源时显示的默认信息。
        controlBar: {
          timeDivider: true,
          durationDisplay: true,
          remainingTimeDisplay: false,
          fullscreenToggle: true // 全屏按钮
        }
      },
      
      journalArr: [], // 日志集合

      activeName: 'spxx', // tab切换
      restaurants: [], // 商品编码
      loadingBut: false,
      loadingButText: '确定',

      tabsName: 'first',

      classificationList: [], // 分类列表
      pageflIndex: 1,
      totalfl: 0,

      isToFl: false,
      flTitle: '添加分类',
      flId: '', // id
      flName: '', // name
      
      initdialog: false,
      bbid:'',  //店铺id
      options1: [],
      isEditingSort: false, // 是否正在编辑排序

    };
  },
  methods: {
    // 编辑排序
    editSort(){
      this.isEditingSort = true;
    },
    // 取消编辑
    handleqxbj(){
      this.isEditingSort = false;
      this.pageIndex = 1;
      this.getinfo();
    },
    // 保存排序
    saveSort(){
      const sortedData = this.goodListInfo.map(item => ({
        goodsid: item.id, // 商品ID
        sort: item.sort, // 排序值
        // sort: item.tempSort || item.sort,
      }));
      console.log(sortedData,'需要批量排序的商品集合');
      // 调用保存排序的 API
      let obj = {
        shopid: this.bbid, // 店铺ID
        list: sortedData, // 需要批量排序的商品集合
      };
      goodssetsort(obj).then(data => {
        if(data.resultCode == 1) {
          this.showAlert('操作排序成功', 'success');
          this.isEditingSort = false;
          this.pageIndex = 1;
          this.getinfo();
        } else {
          this.showAlert(data.resultMsg);
        }
      });
    },
    // 重置
    fnReset() {
      this.goodsName = '';
    },
    // 商品管理&分类管理
    handleTab(val){
      if(!this.bbid) {
        this.showAlert('请重新打开本功能，并选择一家店铺');
        return false;
      }
      if(val.name=='first'){
        this.pageIndex = 1;
        this.getinfo();
      }
      if(val.name=='second'){
        this.pageflIndex = 1;
        this.getflList();
      }
    },
    // tab切换
    handleClick(tab, event) {
      console.log(tab, event);
    },
    // 商品介绍
    contentChangeOne(content) {
      this.content1 = content;
    },
    // 配置清单
    contentChangetWO(content) {
      this.content2 = content;
    },
    // 获取列表数据
    getinfo() {
      if(!this.bbid) {
        this.showAlert('请重新打开本功能，并选择一家店铺');
        return false;
      }
      var obj = {
        bbid: this.bbid,
        // userId: localStorage.Id,
        key: this.goodsName,
        pageIndex: this.pageIndex,
        pageSize: this.pageSize,
      };
      getGoodsWindowList(obj).then(data => {
        if(data.resultCode == 1) {
          this.goodListInfo = data.resultObj.resultObj
          this.total = data.resultObj.rowsCount
          this.resultMsg = data.resultMsg;
        } else {
          this.goodListInfo = []
        }
      });
    },
    // 商品编码联想接口
    querySearchAsync(queryString, cb) {
      let addParams = {
        goodsCode: this.formInline.commodityCode, // 商品编码
        bbId: this.bbid, // 店铺id
        brandTypeId: this.formInline.BrandTypeId || 0, // 品类id
        brandId: this.formInline.BrandId || 0, // 品牌id
        rangeId: this.formInline.constructionId || 0, // 施工方式id
      };
      getSearchWindowsGoods(addParams).then(data => {
        if(data.resultCode == 1) {
          this.restaurants = data.resultObj;
          if(data.resultObj == null) {
            cb(results);
          }
          var results = queryString ? this.restaurants.filter(this.createStateFilter(queryString)) : this.restaurants;
          cb(results);
        }
        if(data.resultCode == 4) {
          this.restaurants = [];
          var results = queryString ? this.restaurants.filter(this.createStateFilter(queryString)) : this.restaurants;
          cb(results);
        }
      });
    },
    createStateFilter(queryString) {
      return (state) => {
        return ( state.goodsCode.indexOf(queryString) >= 0 );
      };
    },
    // 商品编码
    handleSelect(item) {
      console.log(item,'填充数据');
      this.formInline.commodityCode = item.goodsCode; // 商品编码
      let bmId = item; // 商品编码id
      this.editinfo(bmId, 2); // 调用编辑回显数据
      // this.editForm.enterpriseName = item.enterpriseName; // 企业名称
      // this.handleEcho(item.enterpriseNum);
    },
    // 获取施工方式列表
    getBuild() {
      var loginParams = {
        bbid: this.bbid,
      };
      getBbBearRangr(loginParams).then(data => {
        this.constructionMethod = data.resultObj;
      })
    },
    
    // 添加付款比例 行数
    addLine(){
      if(this.MoneyTableData.length >= 5){
        this.showAlert('最多增加5条数据');
        return false;
      }
      let newValue = {
        name: '', // 款项名称
        rate: 0, // 付款比例
      };
      this.MoneyTableData.push(newValue);
    },
    // 删除付款比例 行数
    handleDelete(index){
      this.MoneyTableData.splice(index, 1);
    },
    // 商品品牌
    handleChange(val) {
      this.formInline.BrandTypeId = val[0];
      this.formInline.BrandId = val[1];
    },
    //获取 查询品牌商代理的品类品牌列表
    getBrandByCityId() {
      var obj = {
        bbId: this.bbid
      };
      getMerchantGoodsBrandTypeList(obj).then(data => {
        if(data.ResultCode == 1){
          let that = this;
          let brandList = [];
          data.ResultObj.map(item => {
            let brandData = {value:item.Id,label:item.Name,children:[]}
            brandList.push(brandData)
            if(item.BaseDataList != null) {
              item.BaseDataList.map(brandBusiness => {
                brandData.children.push({value:brandBusiness.Id, label:brandBusiness.Name})
              })
            }
          });
          that.options = brandList
        }else if(data.ResultCode in {0:0,2:2}){
          this.$swal({
            type:'error',
            text: data.ResultMsg,
          })
        }
      });
    },
    handleFile(file) {
      if (file.size > 50*1024 * 1024) {
        this.showAlert('请上传小于50MB的视频');
        return false;
      }
      if (file.type.indexOf("mp4") == -1) {
        this.showAlert('请上传mp4格式的视频');
        return false;
      }

      // 正在上传视频中，请稍后再试
      this.loadingBut = true;
      this.loadingButText = '上传中...';
      this.videoFlag = true;
      this.videoUploadPercent = 0;
      this.timer = setInterval(() => {
        if (this.videoUploadPercent >= 99) {
          clearInterval();
          return;
        }
        this.videoUploadPercent += 1;
      }, 50);
      this.videoSrc = "";
      let obj2 = new FormData();
      obj2.append('file',file);
      //上传视频获取路径
      uploadVedio(obj2, 1).then(data=>{
        if(data.resultCode == 1){
          this.videoImg = localStorage.BaseOssUrl + data.resultObj.r_png; // 视频封面图
          this.videoSrc = localStorage.BaseOssUrl + data.resultObj.r_m3u8; // 视频全路径
          this.videoShortSrc = this.videoSrc.replace(localStorage.BaseOssUrl,'') // 切割
          this.loadingBut = false;
          this.loadingButText = '确定';
          this.videoFlag = false;
          this.videoUploadPercent = 0;
        }else if(data.resultCode in {0:0,2:2}){
          this.$swal({
            type:'error',
            text: data.resultMsg,
          })
        } else {
          this.$swal({
            type:'error',
            text: data.resultMsg,
          })
        }
      }).catch(error => {
        console.log(error)
      });
      // let url = getFileURL(event.target.files[0]); //把当前的 files[0] 传进去
      // if(url) {
      //   this.videoSrc = url;
      //   // this.videoShortSrc = this.videoSrc.replace(localStorage.BaseOssUrl,'')
      //   this.vedioFile = event.target.files[0];
      //   this.$refs.pathClear.value ='';
      // }
      // function getFileURL(file) {
      //   let getUrl = null;
      //   if(window.createObjectURL != undefined) { // basic
      //     getUrl = window.createObjectURL(file);
      //   } else if(window.URL != undefined) { // mozilla(firefox)
      //     getUrl = window.URL.createObjectURL(file);
      //   } else if(window.webkitURL != undefined) { // webkit or chrome
      //     getUrl = window.webkitURL.createObjectURL(file);
      //   }
      //   return getUrl;
      // }
    },
    // 新版本上传oss预览
    newSeevideo(){
      if(this.videoSrc.indexOf("blob:") != -1){
        window.open(this.videoSrc);
      }else{
        this.palySeevideo(this.videoSrc);
      }
    },
    // 播放视频
    palySeevideo(url){
      this.videoVisible = true;
      this.playerOptions.sources[0].src = url;

    },
    closeVideo() {
      // this.$refs.videoPlayer.player.play() // 播放
      // this.$refs.videoPlayer.player.pause() // 暂停
      this.$refs.videoPlayer.player.pause();
    },
    // 删除视频
    delvideo() {
      this.$swal({
        type: "warning",
        text: "重要信息，确认删除视频吗？",
        showCancelButton: true,
        cancelButtonText: "取消",
        confirmButtonText: "确定",
      }).then((res) => {
        if (res.value) {
          this.videoImg='';
          this.videoSrc='';
          this.videoShortSrc='';
        }
      }).catch(() => {
        return;
      });
    },

    // 复选框
    handleSelectionChange(val) {
      this.dowindowArr = [];
      val.forEach(element => {
        this.dowindowArr.push(element.id);
      });
    },

    selSpread() {
      if(this.dowindowArr.length != 1){
        this.showAlert('请选择一条数据 !');
        return false;
      }

      var obj = {
        bbId: this.bbid,
        wgId: this.dowindowArr.join(','),
      }

      selSpread(obj).then(data=>{
        if(data.ResultCode == 1){
          this.$swal({
            type:"success",
            text:data.ResultMsg
          })
          this.getinfo();
        }
      })



    },
    // 上架 & 下架
    onshop(row){
      this.type = row.isOnSale
      this.$swal({
        type:'warning',
        text:this.type==0?"您确定上架此商品么?":"您确定下价架此商品么?",
        showCancelButton:true,
        cancelButtonText: '取消',
        confirmButtonText: '确定',
      }).then((res) => {
        if(res.value){
          this.makesure(row.id)
        }
      })
    },
    // 确定上架
    makesure(rowid){
      var obj = {
        bbId: rowid,
        userId:localStorage.Id,
        operType:3
      }
      EditBBShopIsOpenAndIsCertificate(obj).then(data=>{
        this.shangjiadialog = false;
        if(data.ResultCode == 1){
          this.$swal({
            type:"success",
            text:data.ResultMsg
          })
          this.getinfo();
        }
      })
    },
    //操作向上   向下
    upordown(val, scope) {
      var obj = {
        bbId: this.bbid, // 店铺id
        goodsId: scope.id, // 商品id
        type: val, // 排序类型 1=向上、2=向下
      };
      putSetSort(obj).then(res => {
        if (res.resultCode == 1) {
          this.getinfo();
        } else {
          this.$swal({
            type: "error",
            text: res.resultMsg,
          });
        }
      });
    },
    handleClose(){
      this.dialogVisible = true;
      this.activeName = 'spxx';
    },
    // 新增/编辑 保存
    endAddAndEdit(){
      if(this.newShopType == 1) {
        if(this.pinpai == ""){
          this.showAlert('请选择商品品牌');
          return false;
        }
        if(this.formInline.commodityTypeId == 0) {
          this.showAlert('请选择商品类型');
          return false;
        }
        if(this.formInline.commodityTypeId == 1 && this.formInline.danweiId == "") {
          this.showAlert('请选择单位');
          return false;
        }
      }
      if(this.newShopType == 2) {
        if(this.formInline.constructionId == "") {
          this.showAlert('请选择施工方式');
          return false;
        }
        // if(this.formInline.pingmishu == "") {
        //   this.showAlert('请输入平米数');
        //   return false;
        // }
        if(this.formInline.minimum == '') {
          this.showAlert('请输入最小面积');
          return false;
        }
        if(this.formInline.minimum <= 0) {
          this.showAlert('最小面积 不得小于等于0');
          return false;
        }
        if(this.formInline.maximum == '') {
          this.showAlert('请输入最大面积');
          return false;
        }
        if(Number(this.formInline.maximum) <= Number(this.formInline.minimum)) {
          this.showAlert('最大面积 不得小于等于最小面积');
          return false;
        }
      }
      
      if(this.formInline.commodityCode ==""){
        this.showAlert('请输入商品编码');
        return false;
      }
      if(this.formInline.tradeName == ""){
        this.showAlert('请输入商品名称');
        return false;
      }
      // if(this.newShopType == 1 && this.formInline.stock == ""){
      //   this.showAlert('请输入商品库存');
      //   return false;
      // }
      // if(this.newShopType == 1 && this.formInline.marketPriceOfCommodities == ""){
      //   this.showAlert('请输入商品市场价');
      //   return false;
      // }
      if(this.formInline.promotionPrice == ""){
        this.showAlert('请输入商品促销价');
        return false;
      }
      if(this.formInline.marketPriceOfCommodities){
        if (this.newShopType == 1 && Number(this.formInline.promotionPrice) > Number(this.formInline.marketPriceOfCommodities)) {
          this.showAlert('商品促销价需小于等于商品市场价 !');
          return false;
        }
      }

      // if(this.formInline.commodityTypeId != 3 && this.formInline.advanceDeposit === ""){
      //   this.showAlert('请输入预购定金');
      //   return false;
      // }
      // if (this.formInline.commodityTypeId != 3 && Number(this.formInline.advanceDeposit) > Number(this.formInline.promotionPrice)) {
      //   this.showAlert('预购定金需小于等于商品促销价 !');
      //   return false;
      // }
      // if(Number(this.formInline.advanceDeposit) && Number(this.formInline.promotionPrice)) {
      //   // 如果预购定金 最低值大于了 商品促销价
      //   if (Number(this.formInline.advanceDeposit) > Number(this.formInline.promotionPrice)) {
      //     this.showAlert('预购定金需小于商品促销价 !');
      //     return false;
      //   }
      // }
      if(this.newShopType == 1) {
        if (this.formInline.describe == "" || this.formInline.describe == null) {
          this.showAlert('请输入商品描述');
          return false;
        }
      }
      if(this.imgarr.length == 0){
        this.showAlert('请上传商品图片');
        return false;
      }
      if(this.content1 == ""){
        this.showAlert('请输入商品介绍');
        return false;
      }
      // if(this.newShopType == 2 && this.content2 == "") {
      //   this.showAlert('请输入配置清单');
      //   return false;
      // }
      if (this.newUserType == 5 && this.newShopType == 2 && this.checkedEnable == true && this.commissionAllocationData.find(item =>
        Number(item.platformRate) + Number(item.userRate) + Number(item.firstCoRate) + Number(item.secondCoRate) +
        Number(item.coRate) + Number(item.partnerRate) + Number(item.guideRate) + Number(item.bdRate) + Number(item.designerRate) != 100)) {
        this.showAlert('佣金比例相加必须等于100');
        return false;
      }
      
      let the = this.journalArr.find(item => item.labelName==='' || item.imgs.length===0)
      if (the){
        this.showAlert('请完善空间信息');
        return false;
      }
      setTimeout(()=>{
      this.addData();
      },300)
    },

    addData(){
      if(this.addId) {
        let imgarrData = JSON.parse(JSON.stringify(this.imgarr));
        for(var i = 0; i < imgarrData.length; i++) {
          imgarrData[i] = imgarrData[i].replace( localStorage.BaseOssUrl, '')
        }

        // 空间效果
        let journalData = this.journalArr;
        journalData = journalData.map(item => {
          item.imgs = item.imgs.map(img => {
            return img.replace( localStorage.BaseOssUrl, '')
          })
          return item
        })

        var obj = {
          id: this.addId,
          bbid: this.bbid,
          userId: localStorage.Id,
          brandTypeId: this.formInline.BrandTypeId,
          brandId: this.formInline.BrandId,
          goodsTypeId: this.formInline.commodityTypeId, // 商品类型
          unit: this.formInline.danweiId, // 单位id
          tagId: this.formInline.spflId==''?0:this.formInline.spflId, // 商品分类id
          isPayOnline: this.formInline.zaixianfukuan==false?0:1, // 在线付费 是否支持线上支付 0=否 1=是
          bearRangrId: this.newShopType == 2 ? this.formInline.constructionId : 0, // 施工方式
          minHouseSize: this.formInline.pingmishu, // 平米数
          minSize: this.formInline.minimum, // minimum
          maxSize: this.formInline.maximum, // maximum
          
          goodsCode: this.formInline.commodityCode, // 商品编码
          goodsName: this.formInline.tradeName, // 商品名称
          slogan: this.formInline.describe, // 商品描述
          stock: this.formInline.stock ? this.formInline.stock : 0, // 商品库存
          marketPrice: this.formInline.marketPriceOfCommodities ? this.formInline.marketPriceOfCommodities : 0, // 商品市场价
          promotionPrice: this.formInline.promotionPrice, // 商品促销价
          // deposit: this.formInline.advanceDeposit ? this.formInline.advanceDeposit : 0, // 商品定金价
          deposit: 0, // 预购定金
          isPermanate: this.IsNoLimit === true ? 1 : 0, // 商品有效状态，1=永久有效；0=有效期内有效
          // IsPermanate: this.formInline.isPromotionId, // 有效期
          effectiveStartTime: this.formInline.shopWindowStartTime, // 开始时间
          effectiveEndTime: this.formInline.shopWindowEndTime, // 结束时间
          videoUrl: this.videoShortSrc,
          imgUrls: imgarrData,
          introduce: this.content1, // 商品介绍
          detailedList: this.content2, // 配置清单
          packageByStages: this.newShopType == 2 ? this.MoneyTableData : [], // 付款比例集合
          // 单个产品佣金配置
          isEnableRate: this.checkedEnable, // 启用自定义佣金分发比例
          platformRate: this.commissionAllocationData[0].platformRate, // 平台
          userRate: this.commissionAllocationData[0].userRate, // 消费者
          firstCoRate: this.commissionAllocationData[0].firstCoRate, // 一级共创
          secondCoRate: this.commissionAllocationData[0].secondCoRate, // 二级共创
          coRate: this.commissionAllocationData[0].coRate, // 共创池
          partnerRate: this.commissionAllocationData[0].partnerRate, // 合伙人
          guideRate: this.commissionAllocationData[0].guideRate, // 导购
          bdRate: this.commissionAllocationData[0].bdRate, // BD佣金
          designerRate: this.commissionAllocationData[0].designerRate, // 设计师佣金
          spaceEffects: journalData, // 空间效果
          packUnit: this.formInline.spdanwei, // 商品单位
          packUnitName: this.formInline.spdanwei == 0 ? this.formInline.zidingyi : '', // 整装单位名称
        }
        this.loadingBut = true;
        this.loadingButText = '提交中...';
        putEditGoodsWindow(obj).then(data=>{
          this.loadingBut = false;
          this.loadingButText = '确定';
          if(data.resultCode == 1){
            this.dialogVisible = true;
            this.getinfo();
            this.$swal({
              type:"success",
              text:"编辑保存成功"
            })
            this.content1 = "" // 商品介绍
          }else if(data.resultCode in {0:0,2:2}){
            this.$swal({
              type:'error',
              text: data.resultMsg,
            })
          } else {
            this.$swal({
              type:'error',
              text: data.resultMsg,
            })
          }
        })
      } else { // 新增橱窗商品
        let imgarrData = JSON.parse(JSON.stringify(this.imgarr));
        for(var i = 0; i < imgarrData.length; i++) {
          imgarrData[i] = imgarrData[i].replace( localStorage.BaseOssUrl, '')
        }
        
        // 空间效果
        let journalData = this.journalArr;
        journalData = journalData.map(item => {
          item.imgs = item.imgs.map(img => {
            return img.replace( localStorage.BaseOssUrl, '')
          })
          return item
        })

        var obj = {
          // id: this.addId,
          bbid: this.bbid,
          userId: localStorage.Id,
          brandTypeId: this.formInline.BrandTypeId,
          brandId: this.formInline.BrandId,
          goodsTypeId: this.formInline.commodityTypeId, // 商品类型
          unit: this.formInline.danweiId, // 单位
          tagId: this.formInline.spflId==''?0:this.formInline.spflId, // 商品分类id
          isPayOnline: this.formInline.zaixianfukuan==false?0:1, // 在线付费 是否支持线上支付 0=否 1=是
          bearRangrId: this.newShopType == 2 ? this.formInline.constructionId : 0, // 施工方式
          minHouseSize: this.formInline.pingmishu, // 平米数
          minSize: this.formInline.minimum, // minimum
          maxSize: this.formInline.maximum, // maximum
          goodsCode: this.formInline.commodityCode, // 商品编码
          goodsName: this.formInline.tradeName, // 商品名称
          slogan: this.formInline.describe, // 商品描述
          stock: this.formInline.stock ? this.formInline.stock : 0, // 商品库存
          marketPrice: this.formInline.marketPriceOfCommodities ? this.formInline.marketPriceOfCommodities : 0, // 商品市场价
          promotionPrice: this.formInline.promotionPrice, // 商品促销价
          // deposit: this.formInline.advanceDeposit ? this.formInline.advanceDeposit : 0, // 商品定金价
          deposit: 0, // 预购定金
          isPermanate: this.IsNoLimit === true ? 1 : 0, // 商品有效状态，1=永久有效；0=有效期内有效
          // IsPermanate: this.formInline.isPromotionId, // 有效期
          effectiveStartTime: this.formInline.shopWindowStartTime, // 开始时间
          effectiveEndTime: this.formInline.shopWindowEndTime, // 结束时间
          videoUrl: this.videoShortSrc,
          imgUrls: imgarrData,
          introduce: this.content1, // 商品介绍
          detailedList: this.content2, // 配置清单
          packageByStages: this.newShopType == 2 ? this.MoneyTableData : [], // 付款比例集合
          // 单个产品佣金配置
          isEnableRate: this.checkedEnable, // 启用自定义佣金分发比例
          platformRate: this.commissionAllocationData[0].platformRate, // 平台
          userRate: this.commissionAllocationData[0].userRate, // 消费者
          firstCoRate: this.commissionAllocationData[0].firstCoRate, // 一级共创
          secondCoRate: this.commissionAllocationData[0].secondCoRate, // 二级共创
          coRate: this.commissionAllocationData[0].coRate, // 共创池
          partnerRate: this.commissionAllocationData[0].partnerRate, // 合伙人
          guideRate: this.commissionAllocationData[0].guideRate, // 导购
          bdRate: this.commissionAllocationData[0].bdRate, // BD佣金
          designerRate: this.commissionAllocationData[0].designerRate, // 设计师佣金
          spaceEffects: journalData, // 空间效果
          packUnit: this.formInline.spdanwei, // 商品单位
          packUnitName: this.formInline.spdanwei == 0 ? this.formInline.zidingyi : '', // 整装单位名称
        }
        this.loadingBut = true;
        this.loadingButText = '提交中...';
        postAddGoodsWindow(obj).then(data=>{
          this.loadingBut = false;
          this.loadingButText = '确定';
          if(data.resultCode == 1){
            this.dialogVisible = true;
            this.getinfo()
            this.$swal({
              type:"success",
              text:"新增保存成功"
            })
            this.content1 = "" // 商品介绍
          }else if(data.resultCode in {0:0,2:2}){
            this.$swal({
              type:'error',
              text: data.resultMsg,
            })
          } else {
            this.$swal({
              type:'error',
              text: data.resultMsg,
            })
          }
        })
      }
    },
    // 新增
    showadd() {
      if (this.bbid == 0) {
        this.showAlert('请先在店铺信息功能中创建自己店铺。');
        return false;
      }
      this.getBrandByCityId();
      this.dialogVisible = false;
      this.activeName = 'spxx';
      this.addId = 0;
      this.pinpai = "";
      this.formInline.BrandTypeId = 0;
      this.formInline.BrandId = 0;
      this.formInline.commodityTypeId = 0; // 类型
      this.MoneyTableData = [{
        name: '', // 款项名称
        rate: 0, // 付款比例
      }],
      this.formInline.danweiId = 0; // 单位
      this.lsdwId = 0; // 暂存单位
      this.formInline.spflId = ''; // 商品分类
      this.formInline.zaixianfukuan = false; // 在线付费
      this.formInline.constructionId = ''; // 施工方式
      this.formInline.pingmishu = 0; // 平米数
      this.formInline.minimum = 60; // minimum
      this.formInline.maximum = 120; // maximum
      this.formInline.commodityCode = ""; // 编码
      this.formInline.tradeName = ""; // 名称
      this.formInline.spdanwei = 999; // 商品单位
      this.formInline.describe = ''; // 商品描述
      this.formInline.stock = ""; // 库存
      this.formInline.marketPriceOfCommodities = ""; // 市场价
      this.formInline.promotionPrice = ""; // 促销价
      // this.formInline.advanceDeposit = ""; // 预购定金
      this.formInline.isPromotionId = ""; // 有效期
      this.IsNoLimit = true; // 默认长期有效
      this.isdisabled = true;
      this.imgarr = [];
      this.videoSrc = ""
      this.videoShortSrc = '';
      this.CoverImg = ""
      this.content1 = "" // 商品介绍
      this.content2 = "" // 配置清单
      // 单个产品佣金配置
      this.checkedEnable = false // 启用自定义佣金分发比例
      this.commissionAllocationData[0].platformRate = 0 // 平台
      this.commissionAllocationData[0].userRate = 0 // 消费者
      this.commissionAllocationData[0].firstCoRate = 0 // 一级共创
      this.commissionAllocationData[0].secondCoRate = 0 // 二级共创
      this.commissionAllocationData[0].coRate = 0 // 共创池
      this.commissionAllocationData[0].partnerRate = 0 // 合伙人
      this.commissionAllocationData[0].guideRate = 0 // 导购
      this.commissionAllocationData[0].bdRate = 0 // BD佣金
      this.commissionAllocationData[0].designerRate = 0 // 设计师佣金

      this.journalArr = []
    },
    // 编辑回显数据
    editinfo(row, type) {
      this.getBrandByCityId();
      this.addId = type == 2 ? 0 : row.id;
      var obj = {
        id: row.id
      }
      getGoodsWindowDetails(obj).then(data=>{
        if(data.resultCode == 1){
          this.shopinfo = data.resultObj;
          this.pinpai = [this.shopinfo.brandTypeId, this.shopinfo.brandId];

          this.formInline.BrandTypeId = this.shopinfo.brandTypeId
          this.formInline.BrandId = this.shopinfo.brandId

          this.formInline.commodityTypeId = this.shopinfo.goodsTypeId // 类型
          this.formInline.danweiId = this.shopinfo.unit // 单位
          this.lsdwId = this.shopinfo.unit // 单位
          this.formInline.spflId = this.shopinfo.tagId==0?'':this.shopinfo.tagId // 商品分类
          this.formInline.zaixianfukuan = this.shopinfo.isPayOnline==0?false:true // 在线付费
          this.formInline.constructionId = this.shopinfo.bearRangrId; // 施工方式
          this.formInline.pingmishu = this.shopinfo.minHouseSize // 平米数
          this.formInline.minimum = this.shopinfo.minSize // minimum
          this.formInline.maximum = this.shopinfo.maxSize // maximum
          this.formInline.commodityCode = this.shopinfo.goodsCode // 编码
          this.formInline.tradeName = this.shopinfo.goodsName // 名称
          this.formInline.describe = this.shopinfo.slogan // 商品描述
          this.formInline.stock = type == 2 ? 0 : this.shopinfo.stock // 库存
          this.formInline.marketPriceOfCommodities = this.shopinfo.marketPrice // 市场价
          this.formInline.promotionPrice = type == 2 ? 0 : this.shopinfo.promotionPrice // 商品促销价
          // this.formInline.advanceDeposit = this.shopinfo.deposit // 预购定金
          this.IsNoLimit = this.shopinfo.isPermanate; // 有效时间 1=长久有效；0=有效时间范围有效
          if(this.IsNoLimit == 1) {
            this.IsNoLimit = true;
          } else {
            this.IsNoLimit = false;
            this.formInline.isPromotionId = [this.shopinfo.effectiveStartTime, this.shopinfo.effectiveEndTime]; // 有效期
            this.formInline.shopWindowStartTime = this.shopinfo.effectiveStartTime;
            this.formInline.shopWindowEndTime = this.shopinfo.effectiveEndTime;
          }
          if (this.shopinfo.imgUrls.length >= 5) {
            this.isdisabled = false;
          } else {
            this.isdisabled = true;
          }
          let newImgUrlsData = JSON.parse(JSON.stringify(this.shopinfo.imgUrls));
          for(var i = 0; i < newImgUrlsData.length; i++) {
            newImgUrlsData[i] = newImgUrlsData[i].replace('', localStorage.BaseOssUrl)
          }
          this.imgarr = newImgUrlsData; // 图片集合
          // 付款比例集合
          if (this.shopinfo.packageByStages.length == 0) {
            this.MoneyTableData = [{
              name: '', // 款项名称
              rate: 0, // 付款比例
            }]
          } else {
            this.MoneyTableData = this.shopinfo.packageByStages
          }

          if(this.shopinfo.videoUrl) {
            this.videoShortSrc = this.shopinfo.videoUrl || ' ' // 视频路径
            this.videoSrc = this.shopinfo.videoUrl ? localStorage.BaseOssUrl + this.shopinfo.videoUrl:' '; // 视频路径
          } else {
            this.videoShortSrc = '';
            this.videoSrc = '';
          }

          this.content1 = this.shopinfo.introduce // 商品介绍
          this.content2 = this.shopinfo.detailedList // 配置清单

          // 单个产品佣金配置
          this.checkedEnable = this.shopinfo.isEnableRate // 启用自定义佣金分发比例
          this.commissionAllocationData[0].platformRate = this.shopinfo.platformRate // 平台
          this.commissionAllocationData[0].userRate = this.shopinfo.userRate // 消费者
          this.commissionAllocationData[0].firstCoRate = this.shopinfo.firstCoRate // 一级共创
          this.commissionAllocationData[0].secondCoRate = this.shopinfo.secondCoRate // 二级共创
          this.commissionAllocationData[0].coRate = this.shopinfo.coRate // 共创池
          this.commissionAllocationData[0].partnerRate = this.shopinfo.partnerRate // 合伙人
          this.commissionAllocationData[0].guideRate = this.shopinfo.guideRate // 导购
          this.commissionAllocationData[0].bdRate = this.shopinfo.bdRate // BD佣金
          this.commissionAllocationData[0].designerRate = this.shopinfo.designerRate // 设计师佣金
          
          // 空间效果
          let spaceEffectsData = this.shopinfo.spaceEffects;
          spaceEffectsData = spaceEffectsData.map(item => {
            item.imgs = item.imgs.map(img => {
              return img.replace('', localStorage.BaseOssUrl)
            })
            return item
          })
          
          this.journalArr = spaceEffectsData // 空间效果
          
          this.formInline.spdanwei = this.shopinfo.packUnit; // 整装单位id
          this.formInline.zidingyi = this.shopinfo.packUnitName; // 整装单位名称
          
        }
      })
      this.dialogVisible = false;
      this.activeName = 'spxx';
    },
    // 有效期
    changetime() {
      if(this.formInline.isPromotionId+""=="null"){
        this.formInline.isPromotionId = ["",""]
      }
      this.formInline.shopWindowStartTime = this.formInline.isPromotionId[0];
      this.formInline.shopWindowEndTime = this.formInline.isPromotionId[1];
    },
    // 查询按钮
    onSubmit() {
      this.pageIndex = 1;
      this.getinfo();
    },
    // 获取单位数据
    getdanwei() {
      let that = this;
      var loginParams = {
        tableName: "tBDUnit",
        keyWord: "",
        parentId: ""
      };
      getkind(loginParams).then(data => {
        that.danwei = data.ResultObj;
        that.danwei.unshift({
          Id: 0,
          Name: "请选择"
        });
      })
    },
    // 获取商品单位数据
    getCommodityUnit() {
      let that = this;
      var loginParams = {};
      getUnit(loginParams).then(data => {
        that.spdanweiArr = data.resultObj;
        that.spdanweiArr.unshift({
          id: 999,
          name: "请选择"
        });
      })
    },
    // 获取品牌商商品类型
    goodsType() {
      let that = this;
      var loginParams = {};
      goodsType(loginParams).then(data => {
        that.commodityType = data.resultObj;
        that.commodityType.unshift({
          id: 0,
          name: "请选择"
        });
      })
    },
    // 获取商品分类
    getspfl() {
      let that = this;
      let loginParams = {
        shopid: this.bbid, // 店铺ID
      };
      getshoptaglist(loginParams).then(data => {
        that.spflArr = data.resultObj;
        that.spflArr.unshift({
          tagid: 0,
          tagname: "请选择"
        });
      })
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      this.pageSize = val;
      this.getinfo();
    },
    // 分页
    handleCurrentChange(val) {
      this.pageIndex = val
      this.getinfo()
    },
    // 删除图片
    deleteimg(index) {
      this.imgarr.splice(index, 1);
      // this.FileID.splice(index, 1);
      if (this.imgarr.length >= 5) {
        this.isdisabled = false;
      }else{

        this.isdisabled = true;
      }
    },
    // 商品图片
    beforeAvatarUpload(file) {
      const isSize = new Promise(function(resolve, reject) {
        let width = 1200;
        let height = 1200;
        let _URL = window.URL || window.webkitURL;
        let img = new Image();
        img.src = _URL.createObjectURL(file);
        img.onload = function() {
          // let valid = img.width == width && img.height == height;
          // // let valid = img.width / img.height == 1; // 控制传正方形图片
          // valid ? resolve() : reject();
          resolve()
        };
      })
      // 判断图片大小
      const isLt2M = file.size / 1024 / 1024 <= 5;
      if (!isLt2M) {
        this.showAlert('上传图片大小不能超过 5MB!');
        return;
      }
      // 文件名检查
      const allowedChars = /^[\u4e00-\u9fa5a-zA-Z0-9._\-]+$/;
      // 检查文件名是否包含特殊字符
      if (!allowedChars.test(file.name)) {
        this.showAlert('文件名包含特殊字符，请重命名之后重新上传');
        return false;
      }

      isSize.then(() => {
        var that = this;
        var reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = function(e) {
          // oss 直传图片
          var obj = {type: 11};
          getOssFile(obj).then(data => {
            if (data.resultCode == 1) {
              let ossId = data.resultObj.accesskeyid; // 登录RAM账户id
              let ossSecret = data.resultObj.accesskeysecret; // 登录RAM账户密码
              let ossHost = data.resultObj.hostendpoint; // 请求的OSS服务端点
              let ossfile = data.resultObj.directory; // 保存路径
              let ossbucket = data.resultObj.bucket; // bucket
              localStorage.setItem('keyossId',ossId);
              localStorage.setItem('keyossSecret',ossSecret);
              localStorage.setItem('keyossHost',ossHost);
              localStorage.setItem('keyossfile',ossfile);
              localStorage.setItem('keyossbucket',ossbucket);
              uploadOSS(file,0).then(data => {
                var newOssPic = data;
                that.imgarr.push(newOssPic);
                // that.FileID.push(newOssPic);
                that.FileID = newOssPic.replace(localStorage.BaseOssUrl,'')
              })
            }
          })

        };
        if (that.imgarr.length >= 4) {
          that.isdisabled = false;
        }
        // return file;
      }).catch(() => {
        this.showAlert('上传图片宽高应为1200*1200');
        // return Promise.reject();
      });
      // return isSize;
    },
    // 增加日志
    addJournal() {
      let bqm = this.journalArr.filter(item => {
        return item.labelName == ''
      })
      if (bqm.length > 0){
        this.showAlert('请输入标签名称');
        return false;
      }

      let bqtp = this.journalArr.filter(item => {
        return item.imgs.length == 0
      })
      if (bqtp.length > 0){
        this.showAlert('请至少上传一张图片');
        return false;
      }else{
        this.journalArr.push({labelName: '', imgs: []})
      }
    },
    // 刪除日志
    shanchu(index) {
      this.journalArr.splice(index, 1);
    },
    // 多图上传
    multiGraphUpload(file, item) {
      // 判断图片格式
      const isJPG = file.type === 'image/png' || file.type === 'image/jpg' ||file.type === 'image/jpeg';
      // 判断图片大小
      const isLt2M = file.size / 1024 / 1024 <= 1;
      if (!isJPG) {
        this.showAlert('上传图片只支持jpg、png等格式!');
        return;
      }
      if (!isLt2M) {
        this.showAlert('上传图片大小不能超过 1MB!');
        return;
      }

      if (item.imgsLength) {
        item.imgsLength = item.imgsLength + 1
      } else {
        item.imgsLength = 1
      }
      if (item.imgsLength <= 15) {} else {
        this.showAlert('最多传入15张图片');
        return false;
      }

      var reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = async function(e) {
        // oss 直传图片
        var obj = {
          type: 11
        };
        getOssFile(obj).then(data => {
          if (data.resultCode == 1) {
            let ossId = data.resultObj.accesskeyid; // 登录RAM账户id
            let ossSecret = data.resultObj.accesskeysecret; // 登录RAM账户密码
            let ossHost = data.resultObj.hostendpoint; // 请求的OSS服务端点
            let ossfile = data.resultObj.directory; // 保存路径
            let ossbucket = data.resultObj.bucket; // bucket
            localStorage.setItem('keyossId',ossId);
            localStorage.setItem('keyossSecret',ossSecret);
            localStorage.setItem('keyossHost',ossHost);
            localStorage.setItem('keyossfile',ossfile);
            localStorage.setItem('keyossbucket',ossbucket);
            
          }
        })
        var newOssPic = await uploadOSS(file,0);
        item.imgs.push(newOssPic);
        
      };
      return file;
    },
    // 删除上传图片
    deldetail(item, index) {
      item.imgs.splice(index, 1)
      item.imgsLength = item.imgs.length
    },
    // 商品类型
    changeProductType(val){
      if(val == 2 || val == 6) {
        this.formInline.danweiId = 12;
      }else {
        this.formInline.danweiId = this.lsdwId;
      }
    },
    // 获取暂存单位
    changedw(val){
      this.lsdwId=val;
    },

    // 分类列表
    getflList(){
      let obj = {
        pageindex: this.pageflIndex,
        pagesize: 10,
      };
      getgoodstaglist(obj, this.bbid).then(data => {
        if(data.resultCode == 1) {
          this.classificationList = data.resultObj.list;
          this.totalfl = data.resultObj.totalcount;
        } else {
          this.classificationList = [];
          this.totalfl = 0;
        }
      });
    },
    // 分页
    handlePagination(val){
      this.pageflIndex = val;
      this.getflList();
    },
    // 删除
    endDeletefl(row){
      this.$swal({
      type:'warning',
      text: '重要信息，你确定要删除吗？',
      showCancelButton:true,
      cancelButtonText: '取消',
      confirmButtonText: '确定',
      }).then(res=>{
        if(res.value){
          let obj = {
            shopid: this.bbid, // 店铺ID
            tagid: row.tagid, // 标签ID
            operatorid: localStorage.Id, // 操作人ID
          };
          delgoodstag(obj).then(data => {
            if(data.resultCode == 1) {
              this.$swal({
                type: "success",
                text: "操作成功",
              });
              this.getflList();
              this.getspfl(); // 获取商品分类
            }
          });
        }
      })
    },
    // 添加&编辑
    handlefl(row){
      this.isToFl = true;
      if(row){
        this.flId = row.tagid;
        this.flTitle = '编辑分类';
        getgetinfo('',this.bbid, row.tagid).then(data => {
          if(data.resultCode == 1) {
            this.flId = data.resultObj.tagid; // 分类ID
            this.flName = data.resultObj.tagname; // 分类名称
          }
        });
      }else{
        this.flTitle = '添加分类';
        this.flId = '';
        this.flName = '';
      }
    },
    // 确定分类
    editSubmit(){
      var obj = {
        shopid: this.bbid, // 店铺ID
        tagid: this.flId, // 标签ID
        tagname: this.flName, // 分类名称
        operatorid: localStorage.Id, // 操作人ID
      };
      let thisApi = this.flId?editgoodstag:addgoodstag;
      thisApi(obj).then(data => {
        if(data.resultCode == 1) {
          this.$swal({
            type: "success",
            text: "操作成功",
          });
          this.isToFl = false;
          this.getflList();
          this.getspfl(); // 获取商品分类
        }
      });
    },
    // 初始化查询店铺
    tankuang(){
      let addParams = {
        userId: localStorage.Id, // 当前登陆人id
      };
      userIdentity(addParams).then(data => {
        if (data) {
          if (data.resultCode == 1) {
            if(data.resultObj.length>1){
              // this.bbid = data.resultObj[0].id; // 店铺id
              // this.gonext();
              this.initdialog = true;
              this.options1 = data.resultObj;
            } else { // 默认选中第一个店铺不显示弹框
              this.initdialog = false;
              this.bbid = data.resultObj[0].id; // 店铺id
              this.newShopType = data.resultObj[0].shopType; // 店铺类型
              this.gonext();
            }
            
          }
        }
      })
    },
    gonext(){
      console.log(this.bbid)
      if(this.bbid == ""){
        this.showAlert('请选择店铺名称');
        return false;
      }
      this.initdialog = false;
      this.newUserType = localStorage.UserType;
      this.newBbId = localStorage.BbId;
      this.getinfo();
      this.getdanwei(); // 查询单位
      this.getCommodityUnit(); // 获取商品单位
      this.goodsType(); // 获取商品类型
      this.getspfl(); // 获取商品分类
      
      if(this.newShopType == 2) {
        this.getBuild(); // 施工方式
      }
    },
    // 获取店铺类型
    handleChangeType(val) {
      this.options1.filter(item => {
        if(item.id == val){
          this.newShopType = item.shopType; // 获取店铺类型
        }
      })
    },
    // 关闭el-image遮罩层
    handleClickItem() {
      this.$nextTick(() => {
        // 获取遮罩层dom
        let domImageMask = document.querySelector('.el-image-viewer__mask')
        if (!domImageMask) {
          return
        }
        domImageMask.addEventListener('click', () => {
          // 点击遮罩层时调用关闭按钮的 click 事件
          document.querySelector('.el-image-viewer__close').click()
        })
      })
    },
    
  },
  watch: {
    'IsNoLimit'(newV,oldV) {
      if(this.IsNoLimit == 1) {
        this.formInline.isPromotionId = "";
        this.formInline.shopWindowStartTime = "", //商品有效期开始时间
        this.formInline.shopWindowEndTime = "" //商品有效期结束时间
      }
    },
  },
  mounted() {
    this.tankuang(); // 选择店铺
  }
};
</script>
<style scoped>
.elTextarea {
  width: 80%;
}
.findshop1 {
  font-size: 18px;
  font-weight: 600;
  /* border-bottom: 4px solid #cbc9c9; */
  padding-bottom: 15px;
}
.leftspan {
  font-size: 18px;
  font-weight: 600;
}
.ahref {
  color: #040404;
}
.ahref:hover {
  color: #F56C6C;
}
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9 !important;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 80px;
  height: 80px;
  line-height: 80px;
  border: 1px solid #eee;
  text-align: center;
}
.avatar {
  width: 80px;
  height: 80px;
  display: block;
}
.addCanzhan {
  width: 80px;
  height: 36px;
  color: #fff;
  background: #F56C6C;
  border: 1px solid #F56C6C;
  border-radius: 5px;
  cursor: pointer;
  outline: none;
}

/* 空间效果 */
.spaceEffect {
  width: 90%;
  margin: 20px auto;
  border: 2px dashed #ccc;
}
.dottedLine {
  width: 95%;
  margin: 0 auto;
  border-bottom: 2px dashed #ccc;
}
/* 刪除日志 */
.sahnchuDiv {
  width: 99%;
  display: flex;
  justify-content: space-between;
  margin: 10px auto;
}
.shanBtn {
  height: 30px;
  line-height: 0;
  margin-top: 10px;
}
.primarybtn {
  width: 90%;
  margin: 20px auto;
  text-align: center;
}
/* 多图 */
.upPictures {
  width: 100%;
}
.multigraph {
  width: 80px;
  height: 80px;
  background: cornflowerblue;
  position: relative;
  float:left;
  margin-right:10px;
  margin-top:5px;
  margin-bottom: 5px;
}
.upBtn {
  width: 80px;
  height: 80px;
  line-height: 80px;
  border: 1px solid #DCDFE6;
  border-radius: 5px;
  font-size: 26px;
  color: #999;
  margin-top:5px;
}
</style>


// WEBPACK FOOTER //
// commoditymanagement.vue?1feccebe